import { PerfilService } from '../../services/perfil/perfil.service';

export class AppHeaderController {
  /**
   *
   * @param {angular.IRootElementService} $element
   * @param {angular.IScope} $scope
   * @param {angular.IWindowService} $window
   */
  constructor($element, $scope, $window) {
    this.$element = $element;
    this.$scope = $scope;
    this.$window = $window;
  }

  $postLink() {
    this.$scope.hideBack = typeof(this.$element.attr('hide-back')) !== 'undefined';
  }

  goBack() {
    this.$window.history.back();
  }
}

/**
 * @type {angular.IComponentOptions}
 */
export const AppHeaderComponent = {
  controller: AppHeaderController,
  controllerAs: '$ctrl',
  template: require('./header.component.html'),
  bindings: {
    module: '<',
    page: '<',
    link: '<',
  },
};
